import React from 'react';
import { useCoopRunStore } from '../../store/coopRunSlice';
import { netService } from '../../services/NetService';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 9500,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(8,8,12,0.96)',
  color: '#fff',
  font: '18px sans-serif',
};

export const CoopLoadingOverlay = () => {
  const phase = useCoopRunStore((s) => s.phase);
  if (netService.role === 'offline' || phase !== 'loading') {
    return null;
  }
  return (
    <div style={overlayStyle}>
      <div>Préparation de la partie…</div>
    </div>
  );
};
